<section class="modal-shell" role="dialog" aria-modal="true" [attr.aria-labelledby]="titleId">
  <header class="modal-shell__header" [attr.data-tone]="tone">
    <span class="modal-shell__icon" aria-hidden="true">
      <i [sch-icon]="icon"></i>
    </span>

    <div class="modal-shell__titles">
      <!-- Eyebrow sits inline with the title rather than on its own line, so the
           header stays two rows. Same shape as the page headers in the apps. -->
      <p class="modal-shell__heading">
        @if (eyebrow) {
          <span class="modal-shell__eyebrow">{{ eyebrow }}</span>
        }
        <span class="modal-shell__title" [id]="titleId">{{ title }}</span>
      </p>
      @if (hint) {
        <p class="modal-shell__hint">{{ hint }}</p>
      }
    </div>

    <button
      type="button"
      class="modal-shell__close"
      aria-label="Close"
      [disabled]="busy"
      (click)="close()"
    >
      <i sch-icon="cancel" aria-hidden="true"></i>
    </button>
  </header>

  <div class="modal-shell__body">
    <ng-content></ng-content>
  </div>

  <!-- Projected rather than rendered here: each modal owns its own submit
       semantics, and the actions usually live inside that modal's <form> so the
       submit button keeps working. -->
  <footer class="modal-shell__footer">
    <ng-content select="[modal-actions]"></ng-content>
  </footer>
</section>
